import React from 'react';
import Footer from './components/Footer';
import Form from './components/Form';

export const App = () => {
  return (
    <>
      <main className='app-container'>
        <Form />
      </main>
      <Footer />
    </>
  )
}
